export interface RequestCompletion {
  id: string;
  key: string;
  operationType: string;
}

// OperationRecord.ResultJson historically uses PascalCase; HTTP DTOs use camelCase.
export function completedRequestId(result: unknown): string | undefined {
  if (!result || typeof result !== "object") return undefined;
  const record = result as Record<string, unknown>;
  const id = record.id ?? record.Id;
  if (typeof id !== "string") return undefined;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    id,
  )
    ? id
    : undefined;
}

export function completedSupplierId(result: unknown): string | undefined {
  if (!result || typeof result !== "object") return undefined;
  const record = result as Record<string, unknown>;
  return completedRequestId({ id: record.supplierId ?? record.SupplierId });
}

export function completionPath(completion: RequestCompletion) {
  if (completion.operationType.startsWith("supplier."))
    return `/suppliers/${completion.id}` as const;
  if (completion.operationType.startsWith("sourcing."))
    return `/sourcing/${completion.id}` as const;
  return `/requests/${completion.id}` as const;
}
